module.exports = __webpack_public_path__ + "static/media/call-auth-after.f8fccac7.png";